import { executeRequest, Request } from '@jfs/network'
import { transactionColumnParser } from './../network/parsers/TransactionColumnParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = transactionColumnParser(data)
  return respData
}

const getTxnsColumnV3 = (tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.TransactionColumnV3,
    method: 'GET',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getTxnsColumnV3 }
